window.addEventListener("load", (event) => {

  var modal_loader = document.getElementById("loader");
  modal_loader.classList.add('show');

  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  //var year = urlParams.get('year')
  //var make = urlParams.get('make')
  //var model = urlParams.get('model')
  var year = localStorage.getItem('GYear');
  var make = localStorage.getItem('GMake');
  var model = localStorage.getItem('GModel');
  
   var nameVehicle = document.getElementById("nameVehicle");
  var changeVehicle = document.getElementById("changeVehicle");
  
  var fullVehicleName = year + ' ' + make + ' ' + model;
  
  if(model == 'null'){
    nameVehicle.value = '';
    nameVehicle.innerText = '';
    changeVehicle.innerText = 'Choose Vehicle';
  }else{
    nameVehicle.value = fullVehicleName;
    nameVehicle.innerText = fullVehicleName;
  }

var modal_container_change = document.getElementById("modal_container_change");
  modal_container_change.classList.remove('show');

  var CurrLanguage = window.location.pathname.substring(0,4);
  
  var closeModalChange = document.getElementById("closeModal-change");

  closeModalChange.addEventListener("click", function(){
    modal_container_change.classList.remove('show');
     var contentCollections = document.getElementById("section-collections");
     contentCollections.classList.remove('disabledCollection');
  }); 
  
  
  var idGoChange = document.getElementById("idGoChange");

  idGoChange.addEventListener("click", function(){
    var selectOption1Change = document.getElementById("selectOption1Change");
    var selectOption2Change = document.getElementById("selectOption2Change");
    var selectOption3Change = document.getElementById("selectOption3Change");
    localStorage.setItem('GYear',selectOption1Change.value);
    localStorage.setItem('GMake',selectOption2Change.value);
    localStorage.setItem('GModel',selectOption3Change.value);
  }); 

var modal_container_change = document.getElementById("modal_container_change");
var changeVehicle = document.getElementById("changeVehicle");
changeVehicle.addEventListener("click", function(){
  chanVehicle();
  var selectOption1Change = document.getElementById("selectOption1Change");
  selectOption1Change.addEventListener("change", function(){
    option1Change();
  }); 
  var selectOption2Change = document.getElementById("selectOption2Change");
  selectOption2Change.addEventListener("change", function(){
    option2Change();
  }); 
  var selectOption3Change = document.getElementById("selectOption3Change");
  selectOption3Change.addEventListener("change", function(){
    option3Change();
  }); 
});  

var refreshVehicle = document.getElementById("refreshVehicle");
refreshVehicle.addEventListener("click", function(){
  refreshVeh();
});  

function refreshVeh(){
  localStorage.setItem('GYear',null);
  localStorage.setItem('GMake',null);
  localStorage.setItem('GModel',null); 
  window.location.reload();
}

function resetVehicleSelector(){

  var selectOption1Change = document.getElementById("selectOption1Change");
  var selectOption2Change = document.getElementById("selectOption2Change");
  var selectOption3Change = document.getElementById("selectOption3Change");
  
  var selectOption1ChangeLabel = document.getElementById("vehicle-year-label");
  var selectOption2ChangeLabel = document.getElementById("vehicle-make-label");
  var selectOption3ChangeLabel = document.getElementById("vehicle-model-label");
  
  selectOption1Change.style.display = "block";
  selectOption2Change.style.display = "none";
  selectOption3Change.style.display = "none";
  
  selectOption1ChangeLabel.style.display = "block";
  selectOption2ChangeLabel.style.display = "none";
  selectOption3ChangeLabel.style.display = "none";
  
  
  var option1LiChange = document.getElementById("option1LiChange");
  var option2LiChange = document.getElementById("option2LiChange");
  var option3LiChange = document.getElementById("option3LiChange");


  option2LiChange.style.display = "none";
  option3LiChange.style.display = "none";


  var option1LiTextChange = document.getElementById("option1LiTextChange"); 
  var option2LiTextChange = document.getElementById("option2LiTextChange"); 
  var option3LiTextChange = document.getElementById("option3LiTextChange"); 

  option1LiTextChange.innerText = 'Not selected';
  option2LiTextChange.innerText = 'Not selected';
  option3LiTextChange.innerText = 'Not selected';

  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.innerText = 'Vehicle';


  var idGoChange = document.getElementById("idGoChange");
  idGoChange.style.display = 'none';
  chanVehicle();
};
  
function chanVehicle(){
  
   var contentCollections = document.getElementById("section-collections");
   contentCollections.classList.add('disabledCollection');
  
  
  modal_container_change.classList.add('show');
  
  
   var selectOption1Change = document.getElementById("selectOption1Change");
   var selectOption2Change = document.getElementById("selectOption2Change");
   var selectOption3Change = document.getElementById("selectOption3Change");
  
   var selectOption1ChangeLabel = document.getElementById("vehicle-year-label");
   var selectOption2ChangeLabel = document.getElementById("vehicle-make-label");
   var selectOption3ChangeLabel = document.getElementById("vehicle-model-label");
  
  selectOption1Change.style.display = "block";
  selectOption2Change.style.display = "none";
  selectOption3Change.style.display = "none";
  
   selectOption1ChangeLabel.style.display = "block";
   selectOption2ChangeLabel.style.display = "none";
   selectOption3ChangeLabel.style.display = "none";
  
  
  var option1LiChange = document.getElementById("option1LiChange");
  var option2LiChange = document.getElementById("option2LiChange");
  var option3LiChange = document.getElementById("option3LiChange");
  
    
  option2LiChange.style.display = "none";
  option3LiChange.style.display = "none";
  
  
  var option1LiTextChange = document.getElementById("option1LiTextChange"); 
  var option2LiTextChange = document.getElementById("option2LiTextChange"); 
  var option3LiTextChange = document.getElementById("option3LiTextChange"); 
  
  option1LiTextChange.innerText = 'Not selected';
  option2LiTextChange.innerText = 'Not selected';
  option3LiTextChange.innerText = 'Not selected';
  
  
  
  var idGoChange = document.getElementById("idGoChange");
  idGoChange.style.display = 'none';
  
  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.innerText = 'Vehicle';
  
   var selectOption1Change = document.getElementById("selectOption1Change");
    selectOption1Change.innerText = '';
    var option = document.createElement("option");
    option.value = '';
    option.innerText = '';
    option.type = 'Hidden'
    selectOption1Change.append(option);
  
   var link = apiURL+'/api/WhiteLabel/Vehicle/Years';
    var data = fetch(link, {

    method: 'GET',
    headers: {     
      "content-encoding": "gzip", 
      "content-length": "247",
      "content-type": "application/json; charset=utf-8", 
      "date": "Fri,30 Apr 2021 13:15:47 GMT",
      "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
      "server": "Microsoft-IIS/10.0",
      "vary": "Accept-Encoding", 
      "x-powered-by": "ASP.NET",
      "accept": "text/plain",
      "x-api-key": apiKey,
      "Authorization": apiKey
      }
  })
  .then(res => res.json())
  .then(data => { 
    data.forEach(Data => {    
      var selectOption = document.getElementById("selectOption1Change");
      var option = document.createElement("option");
      option.value = Data;
      option.innerText = Data;
      selectOption.append(option);
    });
  });

} 
function option1Change(){
  
   var selectOption1Change = document.getElementById("selectOption1Change");
   var selectOption2Change = document.getElementById("selectOption2Change");
  
   var selectOption1ChangeLabel = document.getElementById("vehicle-year-label");
   var selectOption2ChangeLabel = document.getElementById("vehicle-make-label");
  
    selectOption2Change.innerText = '';
    var option = document.createElement("option");
    option.value = '';
    option.innerText = '';
    option.type = 'Hidden'
    selectOption2Change.append(option);
  
  selectOption1Change.style.display = "none";
  selectOption2Change.style.display = "block";
  
  selectOption1ChangeLabel.style.display = "none";
  selectOption2ChangeLabel.style.display = "block";
  
  var optionLiText = document.getElementById("option1LiTextChange");
  optionLiText.innerText = selectOption1Change.value;
  optionLiText.value = selectOption1Change.value;
  
  
  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.innerText = '';
  vehicleSelected.append(selectOption1Change.value);
  
  
   var link = apiURL+'/api/WhiteLabel/Vehicle/Makes/'+selectOption1Change.value;
    var data = fetch(link, {

    method: 'GET',
    headers: {     
      "content-encoding": "gzip", 
      "content-length": "247",
      "content-type": "application/json; charset=utf-8", 
      "date": "Fri,30 Apr 2021 13:15:47 GMT",
      "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
      "server": "Microsoft-IIS/10.0",
      "vary": "Accept-Encoding", 
      "x-powered-by": "ASP.NET",
      "accept": "text/plain",
      "x-api-key": apiKey,
      "Authorization": apiKey
      }
  })
  .then(res => res.json())
  .then(data => { 
    data.forEach(Data => {
    
      option2LiChange.style.display = "block";
      var selectOption = document.getElementById("selectOption2Change");
      var option = document.createElement("option");
      option.value = Data;
      option.innerText = Data;
      selectOption.append(option);
    });
  });
}
function option2Change(){
	
   var selectOption1Change = document.getElementById("selectOption1Change");
   var selectOption2Change = document.getElementById("selectOption2Change");
   var selectOption3Change = document.getElementById("selectOption3Change");
  
  
   var selectOption1ChangeLabel = document.getElementById("vehicle-year-label");
   var selectOption2ChangeLabel = document.getElementById("vehicle-make-label");
   var selectOption3ChangeLabel = document.getElementById("vehicle-model-label");
  
    selectOption3Change.innerText = '';
    var option = document.createElement("option");
    option.value = '';
    option.innerText = '';
    option.type = 'Hidden'
    selectOption3Change.append(option);
  
  
  selectOption1Change.style.display = "none";
  selectOption2Change.style.display = "none";
  selectOption3Change.style.display = "block";
  
  selectOption1ChangeLabel.style.display = "none";
  selectOption2ChangeLabel.style.display = "none";
  selectOption3ChangeLabel.style.display = "block";
  
  var optionLiText = document.getElementById("option2LiTextChange");
  optionLiText.innerText = selectOption2Change.value;
  optionLiText.value = selectOption2Change.value;
  
  
  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.append(' ' + selectOption2Change.value);
  
   var link = apiURL+'/api/WhiteLabel/Vehicle/Models/'+selectOption1Change.value+'/'+selectOption2Change.value;
    var data = fetch(link, {

    method: 'GET',
    headers: {     
      "content-encoding": "gzip", 
      "content-length": "247",
      "content-type": "application/json; charset=utf-8", 
      "date": "Fri,30 Apr 2021 13:15:47 GMT",
      "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
      "server": "Microsoft-IIS/10.0",
      "vary": "Accept-Encoding", 
      "x-powered-by": "ASP.NET",
      "accept": "text/plain",
      "x-api-key": apiKey,
      "Authorization": apiKey
      }
  })
  .then(res => res.json())
  .then(data => { 
    data.forEach(Data => {
    
      option3LiChange.style.display = "block";
      var selectOption = document.getElementById("selectOption3Change");
      var option = document.createElement("option");
      option.value = Data;
      option.innerText = Data;
      selectOption.append(option);
    });
  });
}
function option3Change(){
	 
   var selectOption1Change = document.getElementById("selectOption1Change");
   var selectOption2Change = document.getElementById("selectOption2Change");
   var selectOption3Change = document.getElementById("selectOption3Change");
  
   var selectOption1ChangeLabel = document.getElementById("vehicle-year-label");
   var selectOption2ChangeLabel = document.getElementById("vehicle-make-label");
   var selectOption3ChangeLabel = document.getElementById("vehicle-model-label");
  
  selectOption1Change.style.display = "none";
  selectOption2Change.style.display = "none";
  selectOption3Change.style.display = "none";
  
  selectOption1ChangeLabel.style.display = "none";
  selectOption2ChangeLabel.style.display = "none";
  selectOption3ChangeLabel.style.display = "none";
  
  
  
  var optionLiText = document.getElementById("option3LiTextChange");
  optionLiText.innerText = selectOption3Change.value;
  optionLiText.value = selectOption3Change.value;
  
  
  var vehicleSelected = document.getElementById("vehicleSelected");
  vehicleSelected.append(' ' + selectOption3Change.value);
  
  var idGoChange = document.getElementById("idGoChange");
  idGoChange.style.display = 'block';  
  
  if(CurrLanguage == "/fr/"){ idGoChange.href = '/fr/pages/catalog'; }
  else{ idGoChange.href = '/pages/catalog'; }
  
}
  
  var collections = document.getElementById("section-collections");
  var nameVehicle = document.getElementById("nameVehicle");
  
  var fullVehicleName = year + ' ' + make + ' ' + model;
  
  nameVehicle.value = fullVehicleName;
  nameVehicle.innerText = fullVehicleName;

  if(model == 'null'){
    nameVehicle.value = '';
    nameVehicle.innerText = '';
  }else{
    nameVehicle.value = fullVehicleName;
    nameVehicle.innerText = fullVehicleName;
  }

  var link = apiURL+'/api/WhiteLabel/Categories/CategoriesByVehicle/'+year+'/'+make+'/'+model;
  if(model != 'null'){
    var dataYear = fetch(link, {

      method: 'GET',
      headers: {     
        "content-encoding": "gzip", 
        "content-length": "247",
        "content-type": "application/json; charset=utf-8", 
        "date": "Fri,30 Apr 2021 13:15:47 GMT",
        "request-context": "appId=cid-v1:c332b3e3-0008-434d-abd9-a1d6ea35f0dc",
        "server": "Microsoft-IIS/10.0",
        "vary": "Accept-Encoding", 
        "x-powered-by": "ASP.NET",
        "accept": "text/plain",
        "x-api-key": apiKey,
        "Authorization": apiKey
        }
    })
    .then(res => res.json())
    .then(data => { data.forEach(Data => {
      
      var h1 = document.createElement("h1");
      var h1ALink = document.createElement("a");
      h1.className = "header-link";
      if(CurrLanguage == "/fr/"){
        h1ALink.value = Data.categoryNameFR;
        h1ALink.innerText = Data.categoryNameFR;
        h1ALink.href = "/fr/pages/list-items?categoryId=" + Data.categoryId;
      }else{
        h1ALink.value = Data.categoryNameEN;
        h1ALink.innerText = Data.categoryNameEN;
        h1ALink.href = "/pages/list-items?categoryId=" + Data.categoryId;
      }
      h1.append(h1ALink);
      collections.append(h1);
      
      var ah5 = document.createElement("a");
      if(CurrLanguage == "/fr/"){
        ah5.value = "Voir tout " + Data.categoryNameFR + " >";
        ah5.innerText = "Voir tout " + Data.categoryNameFR + " >";
        ah5.href = "/fr/pages/list-items?categoryId=" + Data.categoryId;
      }else{
        ah5.value = "See all " + Data.categoryNameEN + " >";
        ah5.innerText = "See all " + Data.categoryNameEN + " >";
        ah5.href = "/pages/list-items?categoryId=" + Data.categoryId;
      }
      collections.append(ah5);
      
      var br = document.createElement("br");
      collections.append(br);
      
      Data.subCategories.forEach(vData => {
        
        console.log(vData);

        var newLink = document.createElement("a");
        var newDiv = document.createElement("div");
        var vImg = document.createElement("img");
        var vH3 = document.createElement("h3");
        var vA = document.createElement("a");
        vImg.src = vData.categoryImageURL;
        if(CurrLanguage == "/fr/"){
          vH3.value = vData.categoryNameFR;
          vH3.innerText = vData.categoryNameFR;
          
          vA.value = "Explorez cette catégorie >";
          vA.innerText = "Explorez cette catégorie >";
          vA.href = "/fr/pages/list-items?categoryId=" + vData.categoryId;
          newLink.href = "/fr/pages/list-items?categoryId=" + vData.categoryId;
          
        }else{
          vH3.value = vData.categoryNameEN;
          vH3.innerText = vData.categoryNameEN;
          
          vA.value = "Explore this category >";
          vA.innerText = "Explore this category >";
          vA.href = "/pages/list-items?categoryId=" + vData.categoryId;
          newLink.href = "/pages/list-items?categoryId=" + vData.categoryId;
        }
        newDiv.appendChild(vImg);
        newDiv.appendChild(vH3);
        newDiv.appendChild(vA);
        newLink.appendChild(newDiv); 
        collections.append(newLink);
      });
      var vHr = document.createElement("hr");
      collections.append(vHr);
      
      modal_loader.classList.remove('show');      
      })
    });
  }
});  